/** Stars as three marks, e.g. "★★☆", read out as "2 of 3 stars" (P3-TANK-04). */
export function Stars({ n }: { n: number | undefined }) {
  if (n === undefined || n < 1) return null;
  const won = Math.min(3, Math.round(n));
  return (
    <span class="stars" role="img" aria-label={`${String(won)} of 3 stars`}>
      {"★".repeat(won)}
      {"☆".repeat(3 - won)}
    </span>
  );
}
